<script>
  import {AuthThemeUloc} from 'uloc-vue-auth'
  // import {UCheckbox} from 'uloc-vue'

  export default {
    // mixins: [LoginMixin],
    name: 'AuthMain',
    components: {AuthThemeUloc},
    data() {
      return {
        loader: true,
        showPrompt: false,
        lembrar: false,
        config: {
          'erp.login.logo': null
        }
      }
    },
    computed: {
      logo () {
        const c = 'erp.login.logo'
        return this.config && this.config[c] && this.config[c].value !== null && this.config[c].value !== 'null' ? this.config[c].value : null
      },
      logoTmp () {
        // TMP
        if (location.hostname.indexOf('5bitech') > -1){ // TODO: Remover
          return 'https://clientes.suporteleiloes.com/fivebi/Five-blue.png'
        }
        return false
      }
    },
    mounted() {
      this.config = this.$globalConfig
    },
    destroyed() {
    },
    methods: {
      connect() {
        /*this.$uloc.notify(
          type: 'info',
          message: 'Conectando'
        })*/
        this.doLogin()
      },
      testConfig(c) {
        return this.config[c] && this.config[c].value !== null && this.config[c].value !== 'null'
      },
      getConfig(c) {
        return this.config[c] ? this.config[c].value : null
      }
    }
  }
</script>

<template>
  <auth-theme-uloc v-if="loader">
    <template slot="logo">
      <div v-if="logoTmp"><a class="logo-image2"><img :src="logoTmp" width="200" /></a></div>
      <div v-else>ERP SL Enterprise<br><small>v2.0.1</small></div>
<!--      <a class="logo-image2"><img :src="logo" width="200" /></a>-->
    </template>
    <template slot="login-message">
      <p class="bem-vindo">Bem-vindo ao ERP!</p>
      <p class="mensagem">Mais um dia incrível para suas metas e atividades!</p>
      <p class="mensagem">:)</p>
    </template>
  </auth-theme-uloc>
</template>
